<script >
  // packages
  import { descending } from 'd3-array';
  import { intcomma, pluralize } from 'journalize';

  // components
  import CandidateRow from './CandidateRow.svelte';
  import CandidateRowHeader from './CandidateRowHeader.svelte';


 /** @type {string} */
  export let raceId
  //  /** @type {string} */
  // export let caption
  //  /** @type {string | undefined} */
  // export let captionNote
 /** @type {string} */
  export let office

 /**
   * @type {import('../types.d').ReadableCandidateLookup}
   */
  export let candidates

  /**
   * @type {import('../types.d').ReadableCandidateLookup}
   */
  export let nationalCandidates

   /** @type {number} */
  export let totalVotes

  /** @type {number} */
  export let totalNationalVotes

  /** @type {number} */
  export let precinctsReportingPercent
 
  export let alwaysShowCandidates = 4

  export let shouldSortCandidates = false;
  export let hidePrecincts = false;
  /** @type {number | null} */
  export let eevp
  /** @type {boolean} */
  export let face
  
  /** @type {import('../types.d').Crosswalk} */
  export let crosswalk;

  const numberOfCandidates = candidates.length;
  const tooFewToHide = numberOfCandidates <= alwaysShowCandidates + 1;

  let viewAllCandidates = false;

  const hasParties =
    candidates.some(
      (candidate) => candidate.party && candidate.party.length > 0
    ) &&
    !candidates.every(
      (candidate) => candidate.party && candidate.party === 'np'
    );
 
  
  const isBallotMeasure = (office === 'I')||(candidates.some((candidate)=>candidate.party =="yes"));
  const isPresident = office === 'P';

  $: preppedCandidates = shouldSortCandidates
    ? candidates.sort((a, b) => descending(a.votes, b.votes))
    : candidates;

  $: numDecimalsInPercent = raceId === 'GA-S12301-2020-11-03' ? 3 : undefined;
</script>

<div class="contest">
  <table class="contest__candidates">
    <CandidateRowHeader {face} {isBallotMeasure} {isPresident}/>
    <tbody>
      {#each preppedCandidates as candidate, idx (candidate.ap_id)}
        <tr
          class="candidate contest__candidate-row contest__candidate-row-{candidate.party}"
          hidden={!(viewAllCandidates || tooFewToHide || idx < alwaysShowCandidates)}>
          <CandidateRow
            familyName={candidate.family_name}
            givenName={candidate.given_name}
            party={candidate.party}
            isWinner={candidate.is_winner}
            isRunoff={candidate.is_runoff}
            isIncumbent={candidate.is_incumbent}
            votes={candidate.votes}
            nationalVotes={nationalCandidates ? nationalCandidates.find((element) => element.ap_id == candidate.ap_id).votes : ''}
            lookup={face?crosswalk[candidate.ap_id]:''}
            {face}
            {isBallotMeasure}
            {isPresident}
            {hasParties}
            {totalVotes}
            {numDecimalsInPercent}
            {totalNationalVotes}
            />
        </tr>
      {/each}
      {#if !tooFewToHide}
        <tr class="candidate contest__candidate-row">

        <!-- <th colspan={face?5:4} scope="row" class="candidate__cell p-0" style="border-bottom: unset !important;">
            <button class="mt-11 mb-11" on:click={() => (viewAllCandidates = !viewAllCandidates)}> -->

          <th colspan={3} scope="row" class="candidate__cell view-all">
            <button on:click={() => (viewAllCandidates = !viewAllCandidates)}>
              View
              {viewAllCandidates ? 'fewer' : 'all'}
              candidates
              <svg
                class="icon"
                class:icon-angle-down={!viewAllCandidates}
                class:icon-angle-up={viewAllCandidates}>
                <use
                  xlink:href="#{viewAllCandidates ? 'icon-angle-up' : 'icon-angle-down'}" />
              </svg>
            </button>
          </th>
          <!-- <td
          colspan={2}
          class="contest__precincts text-right">
          {intcomma(totalVotes)}
          total vote{pluralize(totalVotes)}
        </td> -->

        </tr>
      {/if}
    </tbody>
  </table>
  <div class="table-footer-row">
    <div class="contest__precincts">
      <span class="text-left">
      {#if !hidePrecincts}
      {#if (eevp >= 0) && (eevp !== null)}
      {eevp}% of expected vote in
      {/if}
      {/if}
      </span>
      <span class="text-right">
        {intcomma(totalVotes)} total vote{pluralize(totalVotes)}
      </span>
    </div>
  </div>
</div>